import { all, call } from 'redux-saga/effects';
import { onAcceptProfileEdit } from './acceptStaffProfileEdit';
import { onAdminResetPasswordStart } from './adminResetPasswordSagas';
import { onBulkStaffUploadStart } from './bulkStaffUpload';
import { onCreateStaffStart } from './createStaff';
import { onDeleteStaffStart } from './deleteStaff';
import { onDeleteStaffDocumentStart } from './deleteStaffDocument';
import { onDocumentUploadStart } from './documentUpload';
import { onDownloadStaffDocumentStart } from './downloadStaffDocument';
import { onDownloadXLSXTempleteStart } from './downloadXLSXTemplete';
import { onEditStaffStart } from './editStaff';
import { onFetchListOfStaffDocuments } from './fetchListOfStaffDocuments';
import { onFetchEditRequests } from './fetchProfileEditRequests';
import { onFetchStaffsStart } from './fetchStaffs';
import { onFetchStaffsStatsStart } from './fetchStaffsStats';
import { onFilterEditRequestsStart } from './filterProfileEditRequests';
import { onFilterStaffsStart } from './filterStaffs';
import { onRejectProfileEdit } from './rejectStaffProfileEdit';
import { onRequestProfileEdit } from './requestStaffProfileEdit';
import { onSaveAndCreateAnotherStaff } from './saveAndCreateAnotherStaff';
import { onSendPasswordResetLinkStart } from './sendPasswordResetLinkSagas';
import { onStaffStatusStart } from './staffStatus';
import { onUpdateStaffPictureStart } from './updateStaffPicture';
import { onUpdateStaffSignatureStart } from './updateStaffSignature';

export function* StaffSagas() {
  yield all([
    call(onCreateStaffStart),
    call(onFetchStaffsStart),
    call(onFetchStaffsStatsStart),
    call(onEditStaffStart),
    call(onDownloadXLSXTempleteStart),
    call(onBulkStaffUploadStart),
    call(onStaffStatusStart),
    call(onFilterStaffsStart),
    call(onSaveAndCreateAnotherStaff),
    call(onUpdateStaffPictureStart),
    call(onUpdateStaffSignatureStart),
    call(onAcceptProfileEdit),
    call(onRejectProfileEdit),
    call(onRequestProfileEdit),
    call(onFetchEditRequests),
    call(onDeleteStaffStart),
    call(onFilterEditRequestsStart),
    call(onDocumentUploadStart),
    call(onFetchListOfStaffDocuments),
    call(onDownloadStaffDocumentStart),
    call(onDeleteStaffDocumentStart),
    call(onAdminResetPasswordStart),
    call(onSendPasswordResetLinkStart),
  ]);
}
